export const readonlyStrEnum = <T extends string>(o: ReadonlyArray<T>): { [K in T]: K } => {
  return o.reduce((res, key) => {
    res[key] = key;
    return res;
  }, Object.create(null)); // there should be a comment here explaining why we didn't use {} here. because this is unexpected behavior.
};
